import colors from '../../colors';

const DayScreenTheme = {
  BarcodeScan: {
    BackgroundColor: colors.black,
    Text: colors.white,
  },
};

export default DayScreenTheme;
